import React, { PropsWithChildren } from "react";
import { AppRoutes } from "src/app/navigation/routes";
import { NavLink } from "react-router-dom";
import { Nav, NavItem } from 'reactstrap';
import ProfileLayout from "src/app/layouts/ProfileLayout";

const HomeLearningBaseScreen: React.FC<PropsWithChildren> = ({ children }) => {

    return (
        <ProfileLayout title={"Home Learning"}>
            <div className="custom-tab custom-tab-two">
                <Nav>
                    
                    <NavItem>
                        <NavLink to={AppRoutes.PLANNING} className={({ isActive }) => (isActive ? 'active text-decoration-none d-block fs-12 fw-bold text-primary' : 'text-gray-300 text-decoration-none d-block fs-12 fw-regular')}>
                            Planning
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to={AppRoutes.RESOURCES_DOCUMENTS} className={({ isActive }) => (isActive ? 'active text-decoration-none d-block fs-12 fw-bold text-primary' : 'text-gray-300 text-decoration-none d-block fs-12 fw-regular')}>
                            Resources & Documents
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
            {children}
        </ProfileLayout>
    )
}

export default HomeLearningBaseScreen;